import { cn } from '@/lib/utils';
import { Camera, ChartBar, CheckCircle, ListChecks } from '@phosphor-icons/react';
import { NavLink } from 'react-router-dom';

/**
 * Bottom navigation táctil para el área de Campo.
 *
 * Pensada para uso en celular con personal de obra:
 *   - 4 íconos grandes con label corto
 *   - Bordes táctiles amplios (h-16 = 64px, recomendación HIG)
 *   - Verde Adelante para la ruta activa, gris para las demás
 *   - safe-area-inset-bottom para iPhone notch/home indicator
 *
 * "Avance" es la sección principal: seleccionar casa → registrar avance.
 */

const items = [
  { to: '/campo/avance', icon: ListChecks, label: 'Avance' },
  { to: '/campo/fotos', icon: Camera, label: 'Fotos' },
  { to: '/campo/cierre', icon: CheckCircle, label: 'Cierre' },
  { to: '/campo/reportes', icon: ChartBar, label: 'Reportes' },
] as const;

export function BottomNavCampo() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-white pb-[env(safe-area-inset-bottom)] print:hidden"
      aria-label="Navegación principal"
    >
      <ul className="mx-auto grid max-w-md grid-cols-4">
        {items.map(({ to, icon: Icon, label }) => (
          <li key={to}>
            <NavLink
              to={to}
              className={({ isActive }) =>
                cn(
                  'flex h-16 flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors',
                  isActive
                    ? 'text-adelante-primary-dark'
                    : 'text-muted-foreground hover:text-foreground',
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icon
                    className="h-6 w-6"
                    weight={isActive ? 'fill' : 'bold'}
                    aria-hidden="true"
                  />
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
